(function () {
  function track(root, trackSel, itemSel, onIndex) {
    var t = root.querySelector(trackSel);
    if (!t) return null;
    var items = function () { return t.querySelectorAll(itemSel); };
    var go = function (i) {
      var list = items(); if (!list.length) return;
      i = Math.max(0, Math.min(i, list.length - 1));
      t.scrollTo({ left: list[i].offsetLeft - t.offsetLeft, behavior: 'smooth' });
    };
    var cur = function () {
      var list = items(), best = 0, d = 1e9;
      list.forEach(function (el, i) { var x = Math.abs(el.offsetLeft - t.offsetLeft - t.scrollLeft); if (x < d) { d = x; best = i; } });
      return best;
    };
    var raf;
    t.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { onIndex && onIndex(cur()); }); }, { passive: true });
    return { go: go, cur: cur, items: items, el: t };
  }

  function initPdp(root) {
    if (root.dataset.rvInit) return; root.dataset.rvInit = 1;
    var n = root.querySelector('[data-rv-n]');
    var thumbs = root.querySelectorAll('[data-rv-thumb]');
    var g = track(root, '[data-rv-gal]', '.rv-gal__s', function (i) {
      if (n) n.textContent = i + 1;
      thumbs.forEach(function (b, j) { b.classList.toggle('is-on', i === j); if (i === j) b.scrollIntoView({ block: 'nearest', inline: 'nearest' }); });
    });
    if (g) {
      thumbs.forEach(function (b) { b.addEventListener('click', function () { g.go(+b.dataset.rvThumb); }); });
      var p = root.querySelector('[data-rv-prev]'), nx = root.querySelector('[data-rv-next]');
      p && p.addEventListener('click', function () { g.go(g.cur() - 1); });
      nx && nx.addEventListener('click', function () { var c = g.cur(); g.go(c + 1 >= g.items().length ? 0 : c + 1); });
    }
    var idInput = root.querySelector('[data-rv-id]');
    var stickyP = root.querySelector('[data-rv-sticky-p]');
    var gifts = root.querySelectorAll('.rv-gift');
    function apply(r) {
      if (!r) return;
      root.querySelectorAll('.rv-bundle').forEach(function (l) { l.classList.toggle('is-on', l.contains(r)); });
      if (idInput) { idInput.value = r.value; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      var pcs = +r.dataset.pcs || 1;
      gifts.forEach(function (gf) { gf.classList.toggle('is-open', pcs >= (+gf.dataset.unlock || 99)); });
      if (stickyP) stickyP.textContent = r.dataset.label + ' · ' + r.dataset.price;
      try { var u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState(null, '', u); } catch (e) {}
    }
    root.querySelectorAll('.rv-bundle input').forEach(function (r) { r.addEventListener('change', function () { apply(r); }); });
    apply(root.querySelector('.rv-bundle input:checked'));
    var sticky = root.querySelector('[data-rv-sticky]'), atc = root.querySelector('[data-rv-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var past = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', past);
          sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        });
      }).observe(atc);
      var sb = sticky.querySelector('[data-rv-sticky-btn]');
      sb && sb.addEventListener('click', function () { atc.click(); });
    }
  }

  function initSlider(root) {
    if (root.dataset.rvInit) return; root.dataset.rvInit = 1;
    var dots = root.querySelector('.rv-dots');
    var s = track(root, '.rv-track', '.rv-slide', function (i) {
      if (dots) dots.querySelectorAll('button').forEach(function (b, j) { b.classList.toggle('is-on', i === j); });
    });
    if (!s) return;
    if (dots) {
      dots.innerHTML = '';
      s.items().forEach(function (_, i) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Vai a ' + (i + 1)); if (!i) b.className = 'is-on'; b.onclick = function () { s.go(i); }; dots.appendChild(b); });
    }
    var p = root.querySelector('[data-rv-prev]'), nx = root.querySelector('[data-rv-next]');
    p && p.addEventListener('click', function () { s.go(s.cur() - 1); });
    nx && nx.addEventListener('click', function () { s.go(s.cur() + 1); });
  }

  function initPop(root) {
    if (root.dataset.rvInit) return; root.dataset.rvInit = 1;
    var d = root.querySelector('dialog'), b = root.querySelector('.rv-pop-badge');
    if (!d || !b) return;
    b.addEventListener('click', function () { d.showModal ? d.showModal() : d.setAttribute('open', ''); });
    root.querySelectorAll('[data-rv-close]').forEach(function (x) { x.addEventListener('click', function () { d.close ? d.close() : d.removeAttribute('open'); }); });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    if (root.dataset.open === 'true') d.showModal();
    var delay = +root.dataset.delay;
    var k = 'rvPopSeen';
    try { if (delay > 0 && !sessionStorage.getItem(k) && !Shopify.designMode) setTimeout(function () { if (!document.querySelector('dialog[open]')) { d.showModal(); try { sessionStorage.setItem(k, 1); } catch (e) {} } }, delay * 1000); } catch (e) {}
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-rv-pdp]').forEach(initPdp);
    (scope || document).querySelectorAll('[data-rv-slider]').forEach(initSlider);
    (scope || document).querySelectorAll('[data-rv-pop]').forEach(initPop);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
